import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import cars from "../../assets/images/cars.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import "../fahrzeugübersicht/Fahrzeugübersicht.css";
import HeroSection from "../heroSection/HeroSection";
import "./Kuriertransport.css";
import AuftragInfoCards from "./auftragInfos";
import TransCiroxKuriertransport from "./TransCitoKuriertransport";
import RundläufeTransCirox from "./RundläufeTransCito";
import Bezahlung from "./Bezahlung";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SEO from "../SEO";
import NavbarMenu from "../heroSection/NavbarMenu";
import { AiOutlineSafety } from "react-icons/ai";
import { FaLocationDot, FaTruckFast } from "react-icons/fa6";
import { MdOutlineAttachMoney } from "react-icons/md";
import { IoTimeOutline } from "react-icons/io5";
import IMG_HERO_BG from "../../assets/images/Kuriertransport-bg.jpg";
import { FaCalendarAlt, FaEuroSign, FaFileSignature, FaRegUser, FaSearch, FaShippingFast, FaTruck, FaTruckLoading, FaTruckMoving, FaUser } from "react-icons/fa";
import { SlEarphonesAlt } from "react-icons/sl";
import AppDownloadSection from "../heroSection/AppDownloadSection";


const Kuriertransport = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);


  const trustBadges = [
    { 
      icon: <FaEuroSign />, 
      label1: t("Kuriertransport.trust.free.label1", "Kostenlos &"), 
      label2: t("Kuriertransport.trust.free.label2", "unverbindlich") 
    },
    { 
      icon: <FaCalendarAlt />, 
      label1: t("Kuriertransport.trust.flexible.label1", "Geprüfte &"), 
      label2: t("Kuriertransport.trust.flexible.label2", "zuverlässige Partner") 
    },
    { 
      icon: <FaLocationDot />, 
      label1: t("Kuriertransport.trust.nationwide.label1", "Schnelle"), 
      label2: t("Kuriertransport.trust.nationwide.label2", "Angebote") 
    },
    { 
      icon: <SlEarphonesAlt />, 
      label1: t("Kuriertransport.trust.support.label1", "Schnelle"), 
      label2: t("Kuriertransport.trust.support.label2", "Angebote") 
    },
  ]

  // Fallback for features to prevent .map error
  const featureTexts = Array.isArray(
  t("Kuriertransport.features", { returnObjects: true })
  )
  ? t("Kuriertransport.features", { returnObjects: true })
  : [
      "Find Transport Orders",
      "Submit an Offer",
      "Partial and Full Loads",
      "Receive Transport Orders",
    ];

  const features = [
    {
      text: featureTexts[0],
      icon: <FaSearch />,
    },
    {
      text: featureTexts[1],
      icon: <FaFileSignature />,
    },
    {
      text: featureTexts[2],
      icon: <FaTruckLoading />,
    },
    {
      text: featureTexts[3],
      icon: <FaShippingFast />,
    },
  ];

  const commissionCards = [
    {
      icon:<FaTruckFast />,
      title:t("Kuriertransport.commission.with.title"),
      subtitle:t("Kuriertransport.commission.with.subtitle"),
      percent:"%"
    },
    {
      icon:<FaTruck />,
      title:t("Kuriertransport.commission.without.title"),
      subtitle:t("Kuriertransport.commission.without.subtitle"),
      percent:"0%"
    }
  ]

  return (
    <>
      <SEO
        title="TransCirox – Kuriertransport | Schneller & günstiger Expressversand"
        description="Kuriertransport und Expresslieferungen einfach und schnell buchen. TransCirox bietet zuverlässigen Kurierdienst für Dokumente, Pakete und mehr in Deutschland."
        keywords="Kuriertransport, Kurierservice, Expresslieferung, Schnelltransport, Transport sofort, Express Transport, Transport heute, Transport in der Nähe"
      />
      {/* <HeroSection
        backgroundImage={cars}
        title={t("Kuriertransport.hero_title", { defaultValue: "Looking for" })}
        titleHighlight={t("Kuriertransport.hero_title_highlight", {
          defaultValue: "Transport Orders?",
        })}
        features={features}
        showQuoteForm={false}
        showCTAButton={true}
        ctaText={t("Kuriertransport.button")}
        ctaRoute="/register/driver"
        formType="kuriertransport"
      /> */}

      {/* ── Original HeroSection (Navbar etc.) ── */}
      <NavbarMenu />
      
      {/* ════════════════════════════════════════
          HERO – "Umzug leicht gemacht"
      ════════════════════════════════════════ */}
      <section
        className="umzug-hero"
        style={{
          backgroundImage: `linear-gradient(to right, rgb(27 27 27 / 97%) 45%, rgb(51 51 51 / 55%) 70%, transparent 100%), url(${IMG_HERO_BG})`,
        }}
        aria-label="Hero"
      >
        <Container>
          <div className="hero-content" data-aos="fade-right">
            <h1 className="text-uppercase">
              {t("Kuriertransport.hero_title", { defaultValue: "Looking for" })}
              <span>
                {t("Kuriertransport.hero_title_highlight", {
                  defaultValue: "Transport Orders?",
                })}
              </span>
            </h1>

            {/* ── Features Badges ── */}
            <div className="features-badges mt-3">
              {features.map((item, i) => (
                <div className="features-badge" key={i}>
                  <div className="badge-icon" aria-hidden="true">
                    {item.icon}
                  </div>

                  <div>
                    <h6>{item.text}</h6>
                  </div>
                </div>
              ))}
            </div>

            {/* ── Commission Cards ── */}
            <Row className="g-3 mt-4">
              {commissionCards.map((card)=>(
                <>
                  <Col md={6}>
                    <div className="commission-card">
                      <div>
                        <div className="commission-icon">
                          {card.icon}
                        </div>
                      </div>
                      <div>
                        <h5>{card.title}</h5>
                        <p>{card.subtitle}</p>
                      </div>
                      <div className="percent">
                        {card.percent}
                      </div>
                    </div>
                  </Col>
                </>
              ))}
            </Row>

            {/* ── CTA button ── */}
            <div className="register-box">
              <div className="register-icon">
                <FaRegUser />
              </div>

              <div className="register-content">
                <h4 className="text-uppercase">
                  {t("Kuriertransport.register.title")}
                </h4>
                <p>
                  {t("Kuriertransport.register.subtitle")}
                </p>
              </div>

              <button className="btn-register text-uppercase" onClick={() => navigate("/register/driver")}>
                {t("Kuriertransport.register.button")} →
              </button>
            </div>
           
            {/* ── Trust badges ── */}
            <div className="trust-badges mt-3">
              {trustBadges.map(({ icon, label1, label2 }, i) => (
                <div className="trust-badge" key={i}>
                  <div className="badge-icon" aria-hidden="true">
                    {icon}
                  </div>
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: label1 }} />
                    <div>{label2}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <section className="service-section py-5 bg-light">
        <AuftragInfoCards />
        <TransCiroxKuriertransport />
        <RundläufeTransCirox />
        <section
          className="text-center mission-section px-md-5"
          data-aos="fade-up"
        >
          <Container>
            <h4 className="mt-3">
              {t("AuftragInfoCards.advantages_title", {
                defaultValue: "Take Advantage of Your Benefits with",
              })}{" "}
              <strong className="text-white">Transcirox</strong>
            </h4>
            <p>
              {t("AuftragInfoCards.advantages_description", {
                defaultValue: "Use it 100% free",
              })}
            </p>
            <Button
              variant="warning"
              size="lg"
              className="bg-orange-500 text-white mt-3"
              onClick={() => navigate("/register/driver")}
            >
              {t("AuftragInfoCards.advantages_button")}
            </Button>
          </Container>
        </section>
        <Bezahlung />
      </section>

      <AppDownloadSection />

      <Footer />
    </>
  );
};

export default Kuriertransport;
